import {Address} from './address';
import {Communication} from './communication';
import {BaseNumberModel} from '@shared/base/base-number-model';

export class Relation extends BaseNumberModel {
  id: number;
  uuid: string;
  number: number;
  title: string;
  firstname: string;
  infix: string;
  familyname: string;
  companyname: string;
  passportValidUntil: Date;
  cocNumber: string;
  vatNumber: string;
  vatTransferred: boolean;
  invoiceExtraText: string;
  invoiceReference: string;
  invoiceReport: number;
  active: boolean;
  addresses: Address[];
  communications: Communication[];
  hasInvoiceEmailAddress: boolean;
  hasReminderEmailAddress: boolean;
  fileCount: number;
}
